import { useToast } from '@app/core';
import {
  Participant,
  useCurrentParticipant,
  useUpdateParticipant,
} from '@app/api';
import { Formik } from 'formik';
import { InformationPaneLayout } from './components/InformationPaneLayout';
import { DevicesFields } from '../components/ProfileFields';
import { useTranslation } from 'react-i18next';

export const OwnedDevices = () => {
  const { t } = useTranslation();
  const { data: participant } = useCurrentParticipant();
  const { mutateAsync: updateParticipant } = useUpdateParticipant(
    participant?.id,
  );

  const toast = useToast();

  const submit = async (values: Participant) => {
    try {
      await updateParticipant(values);
      toast.saved();
    } catch (e) {
      toast.exception(e);
      throw e;
    }
  };

  if (!participant) {
    return null;
  }

  return (
    <Formik initialValues={participant} onSubmit={submit} enableReinitialize>
      <InformationPaneLayout
        icon="ri-smartphone-line"
        title={t('participantSpace.profile.ownedDevices')}
      >
        <DevicesFields noTitle />
      </InformationPaneLayout>
    </Formik>
  );
};
